import { TableColumn, TableStyles } from 'react-data-table-component';
import { User } from 'src/api/wa/store/WaUserStore';
import { getDistance } from './P5_1_UnaddressedPropertiesMap';

export const workerCustomStyles: TableStyles = {
  table: {
    style: {
      backgroundColor: 'transparent',
    },
  },
  responsiveWrapper: {
    style: {
      width: '24rem',
      border: '1px solid #000',
      overflowX: 'auto',
    },
  },
  headRow: {
    style: {
      backgroundColor: 'transparent',
      borderBottom: 'none',
      boxShadow: 'none',
    },
  },
  rows: {
    style: {
      border: 'none',
      backgroundColor: 'transparent',
      minHeight: '1.5rem',
    },
  },
  headCells: {
    style: { border: 'none', padding: 0 },
  },
  cells: {
    style: {
      border: 'none',
      height: '1.5rem',
      padding: 4,
    },
  },
};

export const workerColumns = (
  center: { latitude: number; longitude: number } | null
): TableColumn<User & { displayIndex?: number }>[] => {
  return [
    {
      cell: (row) => <div className="items-start bg-gray-100 pe-2">{row.displayIndex ?? ''}</div>,
      width: '2rem',
    },
    {
      cell: (row) => <div className="pe-2">{row.telephoneNumber ?? ''}</div>,
      grow: 1,
    },
    {
      cell: (row) => <div className="flex flex-row pe-2">{row.name ?? ''}</div>,
      width: '6rem',
    },
    {
      cell: (row) => <div className="flex flex-row pe-2">{row.ldapId ?? ''}</div>,
      width: '5rem',
    },
    {
      id: 'distance',
      cell: (row) => {
        if (
          center &&
          center.latitude != null &&
          row.location &&
          row.location.latitude != null &&
          row.location.longitude != null
        ) {
          const dist = getDistance(
            center.latitude,
            center.longitude,
            row.location.latitude,
            row.location.longitude
          );

          return <div className="">{`${dist.toFixed(1)} km`}</div>;
        }
        return <div className="">-</div>;
      },
      width: 'fit-content',
      right: true,
    },
  ];
};
